import { gql } from 'graphql-request'
import { fragmentLinkQuery } from '../fragments/link'
import { fragmentMaskShapeQuery } from '../fragments/mask-shape'
import { fragmentMediaQuery } from '../fragments/media'

export const GlobalHomePageQuery = gql`
  query GlobalHomePage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    HomePage(locale: $locale, draft: $isPreview) {
      title
      # textColor is aliased per block: Payload publishes a separate enum for
      # each block's select, and GraphQL rejects one field name returning two
      # types. pages/home/index.vue folds the aliases back into textColor.
      content {
        ... on HomeMaskItem {
          id
          blockType
          title
          maskShape ${fragmentMaskShapeQuery}
          useBackgroundColor
          backgroundColor
          useBackgroundColorForHover
          maskTextColor: textColor
          link ${fragmentLinkQuery}
          marginLeft
          marginRight
          marginTop
          marginBottom
          marginLeftMobile
          marginRightMobile
          marginTopMobile
          marginBottomMobile
          deactivated
        }
        ... on HomeImageItem {
          id
          blockType
          image ${fragmentMediaQuery}
          hoverText
          hoverTextMarginLeft
          hoverTextMarginRight
          hoverTextMarginTop
          hoverTextMarginBottom
          hoverTextMarginLeftMobile
          hoverTextMarginRightMobile
          hoverTextMarginTopMobile
          hoverTextMarginBottomMobile
          useBackgroundColor
          backgroundColor
          imageTextColor: textColor
          link ${fragmentLinkQuery}
          marginLeft
          marginRight
          marginTop
          marginBottom
          marginLeftMobile
          marginRightMobile
          marginTopMobile
          marginBottomMobile
          deactivated
        }
      }
    }
  }
`
